import { Component, OnInit } from '@angular/core';
import { FixingSource } from '@approot/models';
import { ConfigService } from '@approot/services';
import { DisplayDefinitionsService } from '../display-definitions.service';

@Component({
  selector: 'app-fixing-sources',
  templateUrl: './fixing-sources.component.html',
  styleUrls: ['./fixing-sources.component.scss']
})
export class FixingSourcesComponent implements OnInit {
  public sources: FixingSource[];

  constructor(
    private svc: DisplayDefinitionsService,
    private configService: ConfigService
  ) {}

  public ngOnInit() {
    this.configService
      .getFixingSources()
      .subscribe(fixingSources => (this.sources = fixingSources));
  }

  public get modalOpen(): boolean {
    return this.svc.showFixingSources;
  }

  public modalChanged(event: boolean) {
    this.svc.showFixingSources = event;
  }
}
